import { MonitorView } from './monitor/MonitorView'
import { useMonitor } from './monitor/useMonitor'

export default function Monitor() {
  return <MonitorView {...useMonitor()} />
}
